if (!customElements.get('momento-gift-card')) {
  class MomentoGiftCard extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.variantInput = this.querySelector('[data-gift-card-variant-id]');
      this.variantButtons = [...this.querySelectorAll('[data-gift-card-variant]')];
      this.priceLabels = [...this.querySelectorAll('[data-gift-card-selected-price], [data-gift-card-visual-value]')];
      this.addButton = this.querySelector('[data-gift-card-add]');

      this.variantButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectVariant(button), { signal: this.abortController.signal });
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    selectVariant(selectedButton) {
      const variantId = selectedButton.dataset.variantId;
      const price = selectedButton.dataset.variantPrice;
      const available = selectedButton.dataset.variantAvailable === 'true';

      if (!variantId || !this.variantInput) return;

      this.variantInput.value = variantId;
      this.variantButtons.forEach((button) => {
        const isSelected = button === selectedButton;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      this.priceLabels.forEach((label) => {
        label.textContent = price;
      });

      if (this.addButton) {
        this.addButton.disabled = !available;
        this.addButton.textContent = available ? 'ADD TO CART' : 'UNAVAILABLE';
      }
    }
  }

  customElements.define('momento-gift-card', MomentoGiftCard);
}
